import { useAuth } from 'modules/auth/hooks/auth'
import React, { createContext, useContext, useEffect, useState } from 'react'
import Frotista from '../domain/entities/Frotista'

import { ListFrotista } from '../domain/usecases/ListFrotista'
import UserRepository from '../infra/repositories/UserRepository'

const listFrotista = new ListFrotista(new UserRepository())

export interface IFrotista {
  id: number
  cnpj: string
  razao_social: string
  email: string
}

interface IFrotistaContextState {
  frotistas: Frotista[]
  frotistaId?: number
  frotista?: Frotista
  setFrotistaId: (frotistaId: number | null) => void
  setFrotista: (frotista: Frotista) => void
  setFrotistas: (frotistas: Frotista[]) => void
}

const FrotistaContext = createContext<IFrotistaContextState>(
  {} as IFrotistaContextState,
)

export function useFrotista(): IFrotistaContextState {
  const context = useContext(FrotistaContext)

  if (!context) {
    throw new Error('useFrotista must be used within an FrotistaProvider')
  }

  return context
}

export const FrotistaProvider: React.FC = ({ children }) => {
  const [frotistaId, setFrotistaId] = useState<null | number>(null)
  const [frotistas, setFrotistas] = useState<Frotista[]>([])
  const [frotista, setFrotista] = useState<Frotista>({} as Frotista)
  const { usuario_id } = useAuth()

  useEffect(() => {
    async function getFrotistasUsuarios() {
      if (usuario_id) {
        try {
          const result = await listFrotista.execute({
            nome: '',
            page: 1,
            per_page: 999,
            active: true,
          })
          setFrotistas(result.data)
        } catch (error) {
          setFrotistas([])
        }
      } else {
        setFrotistas([])
      }
    }

    getFrotistasUsuarios()
  }, [usuario_id])

  return (
    <FrotistaContext.Provider
      value={{
        frotistas,
        frotista,
        frotistaId,
        setFrotistaId,
        setFrotista,
        setFrotistas,
      }}
    >
      {children}
    </FrotistaContext.Provider>
  )
}
